import Temporal from "@/shared/ts/temporal";
import store from "./store";

export default class TemporalDetail {
  public static getDefaultBenefitPaymentDate() {
    return this.getFutureDateBasedOnRetirementDate();
  }

  public static getOtherCashDefaultReceiptDate() {
    const retirementDate = new Date(store.state.retiree.retirementDate);

    if (store.state.retiree.alreadyDrawingPension) {
      return Temporal.getFirstOfNextMonth();
    } else {
      return retirementDate;
    }
  }

  public static getOtherIncomeDefaultPaidFromDate() {
    return this.getFutureDateBasedOnRetirementDate();
  }

  public static getOtherIncomeDefaultPaidToDate(): Date {
    const paidFromDate = this.getFutureDateBasedOnRetirementDate();
    paidFromDate.setFullYear(paidFromDate.getFullYear() + 5);
    return paidFromDate;
  }

  private static getFutureDateBasedOnRetirementDate(): Date {
    const retirementDate = new Date(store.state.retiree.retirementDate);
    const currentDate = new Date();

    if (retirementDate > currentDate) {
      return retirementDate;
    }

    return Temporal.getFirstOfNextMonth();
  }
}
